import React from 'react';
import * as rmd from 'material-ui';
import _ from 'lodash';
import PropTypes from 'prop-types';
import RCore from 'RCore';
import config from 'cfg';
import SMPostDialog from './SMPostDialog';
import qs from 'query-string';

import WidgetNestedMenu from './WidgetNestedMenu';

class SMPostPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.templateObserver = this.context.templateObserver;
    }

    static contextTypes = {
        user: PropTypes.object.isRequired,
        templateObserver: PropTypes.object.isRequired,
        campaigns: PropTypes.array.isRequired,
        widgets: PropTypes.array.isRequired
    };

    render() {
        let templateId = this.templateObserver.getTemplate();
        const { widgets } = this.context;

        let widget = _.find(widgets, w => w.id === this.props.params.widgetId);

        return (
            <div>
                <div className="wdp-container">
                    <SMPostDialog
                        key={templateId + '_' + (widget && widget.name)}
                        templateId={templateId}
                        previewWidget={
                            widget &&
                            _.extend({}, widget, {
                                name: widget.id,
                                props: RCore.obj2InjectorParams(this.props.location.query)
                            })
                        }
                        title={
                            <WidgetNestedMenu
                                widgets={widgets}
                                widgetId={this.props.params.widgetId}
                                onChange={(e, widget) => {
                                    this.props.router.push(`/sm/browser/post/${widget.id}`);
                                }}
                            />
                        }
                        open
                        inline
                        showAllParams
                        onRequestClose={() =>
                            this.setState({ widget: null }, () => {
                                this.props.router.replace({ pathname: location.pathname });
                            })
                        }
                        onPropsChange={props => {
                            let location = this.props.location;
                            const query = qs.stringify(RCore.prepareWidgetPropsObj(props));
                            window.history.pushState({}, '', location.pathname + '?' + query);
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default SMPostPage;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/SMPostPage.js
 **/